import { render, staticRenderFns } from "./workwithus.vue?vue&type=template&id=2f76c54e&scoped=true&"
import script from "./workwithus.vue?vue&type=script&lang=js&"
export * from "./workwithus.vue?vue&type=script&lang=js&"
import style0 from "./workwithus.vue?vue&type=style&index=0&id=2f76c54e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f76c54e",
  null
  
)

export default component.exports